
import { DeviceOpeningLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DeviceOpeningLogEntryContent extends Vue {
  @Prop()
  logEntry!: DeviceOpeningLogEntry
}
